import { getFirebaseConfig } from '../config'
import firebaseStart, { getFirebaseApp } from '../services/firebase'
import { getAuth, signInAnonymously } from 'firebase/auth'
import { useContext } from 'react'
import { AuthContext } from '../contexts/auth-context'

function useAuth() {
  const firebaseConfig = getFirebaseConfig()
  let firebaseApp = getFirebaseApp()

  if (!firebaseApp) {
    firebaseStart()
    firebaseApp = getFirebaseApp()
  }

  const auth = getAuth(firebaseApp)
  auth.tenantId = firebaseConfig.firebaseTenant

  const {
    isAuthenticated,
    idToken,
    setIsAuthenticated,
    setIdToken,
  } = useContext(AuthContext)

  async function login() {

    await signInAnonymously(auth)

    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken(true)
      setIdToken(token)
      setIsAuthenticated(true)
    }
  }

  return {
    isAuthenticated,
    login,
    idToken,
  }
}

export default useAuth
